<script setup>
import { computed, ref } from "vue";
import { monthsM } from "db";
import { getUnixTime } from "date-fns";

const props = defineProps(["modelValue"]);
defineEmits(["update:modelValue"]);

const year = ref();

if (Number.isFinite(props.modelValue))
	year.value = new Date(props.modelValue * 1000).getFullYear();
else
	year.value = new Date().getFullYear();

const now = new Date();

const current = { year: now.getFullYear(), month: now.getMonth() };

const selected = computed(() => {
	if (!Number.isFinite(props.modelValue))
		return { year: null, month: null };

	const date = new Date(props.modelValue * 1000);

	return { year: date.getFullYear(), month: date.getMonth() };
});
</script>

<template>
	<div class="vui-month-picker">
		<div class="head">
			<button type="button" class="vui-btn text" @click="year--"><i class="fa-solid fa-chevron-left"></i></button>
			<div class="year">{{ year }}</div>
			<button type="button" class="vui-btn text" @click="year++"><i class="fa-solid fa-chevron-right"></i></button>
		</div>
		<div class="body">
			<button
				v-for="(month, idx) in monthsM"
				type="button"
				class="vui-btn text month"
				:class="{
					current: current.year === year && current.month === idx,
					selected: selected.year === year && selected.month === idx
				}"
				@click="$emit('update:modelValue', getUnixTime(new Date(year, idx)))"
			>
				{{ month }}
			</button>
		</div>
	</div>
</template>
